import { createSelectorHooks } from 'auto-zustand-selectors-hook';
import { shallowEqual, useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

import { IsEmptyOrNullOrUndefined } from '@helpers/Utils';

import useStoreCurrentUser from '../_storeCurrentUser';

const ProtectedRoute = ({ module_name = '' }) => {
  const { user } = useSelector((state) => ({ user: state?.auth?.user?.user }), shallowEqual);

  if (!user) {
    return <Navigate to="/auth/login" replace />;
  }

  const _storeCurrentUser = createSelectorHooks(useStoreCurrentUser);
  const __allowedModules = _storeCurrentUser.useAllowedModules();

  const isAllowed = IsEmptyOrNullOrUndefined(module_name) ? true : __allowedModules.find(a => a?.toLowerCase() === module_name?.toLowerCase())

  if (!isAllowed) {
    return <Navigate to="/home" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;